import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Message } from '../classes/message';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { UsersService } from './users.service';
import { UserGroup, User } from '../classes/user';
import { HttpClientModule,HttpClient } from '@angular/common/http';
import { GlobalSearchService } from './globalsearchservice.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';

@Injectable({
	providedIn: 'root'
})
export class OmsService {


	key = 'UET6DFMPAXW7BKCB';
	config: any;
	//todo make connection reusabel
	socket: any;
	details: any;
	user : any = [];
	environment = {
		production: false,
		SOCKET_ENDPOINT: 'wss://cleve.tireserv.com:5009',
		user: '',
	};
	package: any = '';

	// Connection state management
	connectionState: 'disconnected' | 'connecting' | 'connected' | 'error' = 'disconnected';
	connectionAttempts: number = 0;
	maxConnectionAttempts: number = 5;
	healthCheckInterval: any = null;
	lastPingTime: number = 0;

	constructor(public userService: UsersService, private http: HttpClient, private globalSearchService: GlobalSearchService,private _configSvc: RuntimeConfigLoaderService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe( (result) => {
			this.user = result;
		});

		this.environment.SOCKET_ENDPOINT = this.config.apiServer.socket,
		this.environment.user = this.user.user.userid;

		this.globalSearchService.socket.subscribe( existingsocket => {
			if(existingsocket) {
				this.socket = existingsocket;
			}
		});
	}

	setupSocketConnection(token: string) {

		if(!this.socket) {

			if(!this.user) {
				token = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
			} else {
				token = this.user.user.userid;
			}

			this.socket = io(this.environment.SOCKET_ENDPOINT, {
				auth: { token },
				reconnection: true,
				reconnectionAttempts: 5,
				reconnectionDelay: 1000,
				reconnectionDelayMax: 5000,
				timeout: 20000,
				forceNew: false
			});

			// Add comprehensive connection event handling
			this.setupConnectionEventHandlers();

			this.globalSearchService.socket.next(this.socket);
		}

		this.globalSearchService.socket.subscribe((results: any[]) => {
			this.socket = results;
			if (this.socket && !this.socket.connected) {
				this.socket.connect();
			}
		});
	}

	// Connection event handlers for better reliability
	private setupConnectionEventHandlers(): void {
		if (!this.socket) return;

		// Connection established
		this.socket.on('connect', () => {
			this.connectionState = 'connected';
			this.connectionAttempts = 0;
			console.log('Socket connected successfully');
			this.startHealthMonitoring();
		});

		// Connection lost
		this.socket.on('disconnect', (reason: string) => {
			this.connectionState = 'disconnected';
			console.log('Socket disconnected:', reason);
			this.stopHealthMonitoring();
			
			// If it's a server disconnect, try to reconnect
			if (reason === 'io server disconnect') {
				this.socket.connect();
			}
		});

		// Connection error
		this.socket.on('connect_error', (error: any) => {
			this.connectionState = 'error';
			this.connectionAttempts++;
			console.error('Socket connection error:', error);
			
			// If we've exceeded max attempts, reset and try again
			if (this.connectionAttempts >= this.maxConnectionAttempts) {
				console.log('Max connection attempts reached, resetting...');
				this.connectionAttempts = 0;
				setTimeout(() => {
					if (this.socket) {
						this.socket.connect();
					}
				}, 5000);
			}
		});

		// Reconnection attempts
		this.socket.on('reconnect_attempt', (attemptNumber: number) => {
			this.connectionState = 'connecting';
			console.log(`Reconnection attempt ${attemptNumber}`);
		});

		// Reconnection successful
		this.socket.on('reconnect', (attemptNumber: number) => {
			this.connectionState = 'connected';
			this.connectionAttempts = 0;
			console.log(`Reconnected after ${attemptNumber} attempts`);
		});

		// Reconnection failed
		this.socket.on('reconnect_failed', () => {
			this.connectionState = 'error';
			console.error('Reconnection failed after all attempts');
		});

		// Ping/pong for connection health monitoring
		this.socket.on('pong', (latency: number) => {
			console.log(`Socket ping: ${latency}ms`);
		});
	}

	// Get current connection state
	getConnectionState(): string {
		return this.connectionState;
	}

	// Check if socket is healthy
	isSocketHealthy(): boolean {
		return this.socket && this.socket.connected && this.connectionState === 'connected';
	}

	// Force reconnection
	forceReconnect(): void {
		if (this.socket) {
			this.connectionState = 'connecting';
			this.socket.disconnect();
			this.socket.connect();
		}
	}

	// Start connection health monitoring
	startHealthMonitoring(): void {
		if (this.healthCheckInterval) {
			clearInterval(this.healthCheckInterval);
		}

		this.healthCheckInterval = setInterval(() => {
			if (this.socket && this.socket.connected) {
				this.lastPingTime = Date.now();
				this.socket.emit('ping');
				
				// Check if we haven't received a pong in 30 seconds
				setTimeout(() => {
					if (Date.now() - this.lastPingTime > 30000) {
						console.warn('Socket health check timeout, forcing reconnection');
						this.forceReconnect();
					}
				}, 30000);
			}
		}, 30000); // Ping every 30 seconds
	}

	// Stop connection health monitoring
	stopHealthMonitoring(): void {
		if (this.healthCheckInterval) {
			clearInterval(this.healthCheckInterval);
			this.healthCheckInterval = null;
		}
	}

	// Handle message receive event
	subscribeToMessages = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if(!this.socket.connected) {
			this.joinRoom('messages');
		}

		this.socket.on('messagesent', msg => {
			return cb(null, msg);
		});
	}

	subscribeToRecScanUpdate = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		// Ensure connection is established before joining room
		if (!this.isSocketHealthy()) {
			console.warn('Socket not healthy, attempting to reconnect...');
			this.forceReconnect();
		}

		this.joinRoom('RecScanUpdate');
		this.socket.on('recscansent', msg => {
			return cb(null, msg);
		});

		this.socket.on('recscanupdated', msg => {
			return cb(null, msg);
		});
	}

	sendRecScanUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		// Ensure connection is healthy before sending
		if (this.isSocketHealthy()) {
			this.socket.emit('recscansent', { data , roomName }, cb);
		} else {
			console.warn('Socket not healthy, cannot send rec scan update');
			if (cb) cb(new Error('Socket not connected'));
		}
	}

	subscribeToDriverChange = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('driverchange');

		this.socket.on('welcome', msg => {
			return cb(null, msg);
		});

		this.socket.on('driverchanged', msg => {
			return cb(null, msg);
		});
	}

	sendDriverUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('driverchanged', { data , roomName }, cb);}
	}

	subscribeToCarts = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('CartRoom');

		this.socket.on('cartupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('updatecarts', msg => {
			return cb(null, msg);
		});
	}

	sendCartUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('cartupdate', { data , roomName }, cb);}
	}

	subscribeToCards = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('OrderBoard');

		this.socket.on('dispatchupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('cardupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('orderupdate', msg => {
			return cb(null, msg);
		});

		this.socket.on('pickupdate', msg => {
			 return cb(null, msg);
		});

		this.socket.on('orderitempick', msg => {
			 return cb(null, msg);
		});

		this.socket.on('loadbayupdate', msg => {
			console.log(msg);
			return cb(null, msg);
		})
	}

	subscribeToPuts = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		this.socket.on('pickupdate', msg => {
			return cb(null, msg);
		});
	}

	subscribeToPicks = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		this.socket.on('pickupdate', msg => {
			return cb(null, msg);
		});
	}

	subscribeToOrderPicks = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.socket.on('orderitempick', msg => {
			return cb(null, msg);
		});
	}

	subscribeToOrderUpdates = (cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		this.socket.on('orderupdate', msg => {
			return cb(null, msg);
		});
	}

	sendOrderCheckUpdate = ({ data, roomName }, cb) => {


		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('orderitemcheck', { data , roomName }, cb);}

	}

	sendOrderPickUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('orderitempick', { data , roomName }, cb);}
	}

	subscribeToOpenOrders = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		this.socket.on('openorders', msg => {
			return cb(null, msg);
		});
	}

	printCommandSent = false;

	setNewOrder() {
		this.printCommandSent = false;
	}

	setPrintedOrder() {
		this.printCommandSent = true;
	}

	getPrintStatus(){
		return this.printCommandSent;
	}

	// 	sendPrintCommand = ({ data, roomName }, cb) => {
	// 		if (!this.socket) {
	// 			this.setupSocketConnection(this.user.user.userid);
	// 		}
	//
	// 		if (this.socket && !this.printCommandSent) {
	//
	// 			this.socket.emit('printPdf', { data, roomName }, () => {
	//
	// 				if (this.socket) {
	// 					this.socket.disconnect();
	// 					this.socket = null;
	// 				}
	// 				if (cb) {
	// 					cb();
	// 				}
	// 				// Set printCommandSent to false after everything is done
	// 				this.printCommandSent = false;
	// 			});
	// 			this.printCommandSent = true; // Mark command as sent
	// 		} else {
	// 			console.log("Print command already sent or socket not available.");
	// 		}
	// 	}

	sendPrintCommand = ({ data, roomName }, cb) => {

		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid);
		}

		if (this.socket && !this.printCommandSent) {
			// alert('sending');
			//"Sending print command...");
			console.log('sent');
			this.socket.emit('printPdf', { data, roomName }, () => {

				if (this.socket) {
					this.socket.disconnect();
					this.socket = null;
					this.printCommandSent = true;
					console.log('Socket disconnected.');
				}
				if (cb) {
					cb();

					if(this.socket) {
						this.socket.disconnect();
						this.socket = null;
						this.printCommandSent = true;
						console.log('Socket disconnected Again.');
					}
				}
			});
		} else {
			//"Print command already sent or socket not available.");
		}
	}

	sendOrderUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('orderupdate', { data , roomName }, cb);}

	}

	sendOpenOrderUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('openorders', { data , roomName }, cb);}

	}

	sendSnoozeUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('snoozekupdate', { data , roomName }, cb);}

	}

	sendSnoozeRemove = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('snoozeremove', { data , roomName }, cb);}

	}

	sendCreditUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('creditupdate', { data , roomName }, cb);}
	}

	sendAutoPutUpdate= ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('putautoupdate', { data , roomName }, cb);}
	}

	rgaAutoPutUpdate= ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('rgaautoupdate', { data , roomName }, cb);}
	}
	sendPutUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('putupdate', { data , roomName }, cb);}
	}

	sendPickUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('pickupdate', { data , roomName }, cb);}
	}

	sendMessage = ({ message, roomName }, cb) => {
		if (this.socket) {this.socket.emit('message', { message , roomName }, cb);}
	}

	sendCardUpdate = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('updatecard', { data, roomName }, cb);}
	}

	sendDispatchUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('dispatchupdate', { data, roomName }, cb);}
	}

	sendDispatchPositionUpdate = ({ data, roomName }, cb) => {

		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('dispatchpositionupdate', { data, roomName }, cb);}
	}

	sendLoadSheet = ({ data, roomName }, cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}

		if (this.socket) {this.socket.emit('loadsheetupdate', { data, roomName }, cb);}
	}


	loadingBayAssigned = ({ data, roomName }, cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('bayassigned', { data, roomName }, cb);}
	}

	subscribeToLoadingBays = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if(!this.socket.connected) {
			this.joinRoom('loadingbays');
		}
		this.socket.on('bayassigned', msg => {
			return cb(null, msg);
		});
	}

	subscribeToBayScans = (cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if(!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayScan', msg => {
			return cb(null, msg);
		});
	}

	sendBayScan = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('loadbayScan', { data, roomName }, cb);}
	}
	sendTruckClearedAlert = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('truckcleared', { data, roomName }, cb);}
	}

	sendWillCallAlert = ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) {this.socket.emit('willcallorder', { data, roomName }, cb);}
	}

	subscribeToTruckClearAlerts = (cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('truckalerts');

		this.socket.on('truckcleared', msg => {
			return cb(msg);
		})
	}

	subscribeToWillCallAlerts = (cb) => {
		if(!this.socket){
			this.setupSocketConnection(this.user.user.userid)
		}

		this.joinRoom('truckalerts');

		this.socket.on('willcallorder', msg => {
			return cb(msg);
		})
	}

	joinRoom = (roomName) => {
		this.socket.emit('join', roomName);
	}

	public getConnection() {
		this.globalSearchService.socket.subscribe((results: any[]) => {
			this.socket = results;
		});
	}

	//HTTP REQUESTS
	public getPicks() {
		const method = 'oms/pick';
		return this.http.get(this.setEndPoint(method));
	}

	public getOrderCards() {
		const method = 'oms/cards';
		return this.http.get(this.setEndPoint(method));
	}

	public getRunPick(column: any) {
		const method = 'oms/runpick&column='+column;
		return this.http.get(this.setEndPoint(method));
	}

	public getRecalc(column) {
		const method = 'oms/recalc&column='+column+this.getKey();
		return this.http.get(this.setEndPoint(method));
	}

	private getApi() {
		return this.config.apiServer.crossPoint;
	}

	private getPackage() {
		const p = sessionStorage.getItem('app')
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	private getApiKey() {
		return '&key='+this.config.apiCredentials.clientId+'&userid='+this.user.user.userid;
	}

	public getKey() {
		return '&apikey='+this.key+'&userid='+this.user.user.userid;
	}

	private setEndPoint(method: any) {
		return this.setEndPoint(method)+this.getApiKey()+ this.getPackage()
	}

	disconnect() {
		if (this.socket) {
			this.socket.disconnect();
			this.socket.connect();
		}
	}

	disconnectOnly(){
		if(this.socket){
			this.socket.disconnect();
			this.socket = false;
			console.log('disconnected from socket');
		}
	}

	randomString(length: any, chars: any) {
		let result = '';
		for (let i = length; i > 0; --i) {result += chars[Math.floor(Math.random() * chars.length)];}
		return result;
	}

	sendloadscan = ({ data, roomName }, cb) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) { this.socket.emit('loadbayScanWifi', { data, roomName }, cb); }
	}

	sendloadbayupdate = ({ data, roomName }, cb) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) { this.socket.emit('loadbayUpdate', { data, roomName }, cb); }
	}


	subscribeToBayScanResults = (cb) => {
		this.disconnect()
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayScanResult', msg => {
			return cb(null, msg);
		});
	}

	subscribeToBayScanUpdates = (cb) => {
		this.disconnect()
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayScanUpdate', msg => {
			return cb(null, msg);
		});
	}


	sendStickerscan = ({ data, roomName }, cb) => {
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (this.socket) { this.socket.emit('loadbayScanSticker', { data, roomName }, cb); }
	}

	subscribeToStickerScanResults = (cb) => {
		this.disconnect()
		if (!this.socket) {
			this.setupSocketConnection(this.user.user.userid)
		}
		if (!this.socket.connected) {
			this.joinRoom('scanners');
		}
		this.socket.on('loadbayStickerResult', msg => {
			return cb(null, msg);
		});
	}

}
